import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { TeaserBoxLink } from '../../../shared/teaser-box/teaser-box.component'
import { Image } from '../../../types'
import { TeaserBoxMediaData } from '../teaser-boxes-media.component'
import { CmsConverterService, defaultLinkData, defaultTextInput } from '../../../../services/cms-converter/cms-converter.service'
import { ImageViewport } from '../../../../enums/image-viewports'

@Injectable({ providedIn: 'root' })
export class TeaserBoxImageConverter extends CmsConverterService<TeaserBoxImageData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    const original = formData.st_image_reference.value?.baseUrl ?? ''
    const xl = CmsConverterService.getImageSize(formData.st_image_reference, ImageViewport.W2H1, 1920)
    const lg = CmsConverterService.getImageSize(formData.st_image_reference, ImageViewport.W2H1, 1200)
    const md = CmsConverterService.getImageSize(formData.st_image_reference, ImageViewport.W2H1, 990)
    const sm = CmsConverterService.getImageSize(formData.st_image_reference, ImageViewport.W2H1, 768)
    const xs = CmsConverterService.getImageSize(formData.st_image_reference, ImageViewport.W2H1, 480)
    return {
      image: {
        original,
        xl,
        lg,
        md,
        sm,
        xs,
        altText: formData.st_alt_text.value || formData.st_image_reference.value?.[0]?.value?.target?.altTag || '',
        lazyLoad: original.length ? formData.st_image_lazy_loading.value || true : false
      },
      teaserBoxData: {
        link: formData.st_link ?? defaultLinkData as TeaserBoxLink,
        description: formData.st_description ?? defaultTextInput,
        headline: formData.st_headline ?? defaultTextInput,
        label: formData.st_label ?? defaultTextInput,
        sticker: formData.st_highlighting.value?.identifier ?? '',
        backgroundColor: 'bg-' + (formData.st_backgroundcolor.value?.identifier ?? 'grey'),
        promotionTracking: false
      },
    }
  }
}

export const TEASER_BOX_IMAGE_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, TeaserBoxImageData>>('TeaserBoxImageConverter')

export interface TeaserBoxImageData extends TeaserBoxMediaData {
  image: Image;
}
